import { adminHttpClient } from '../../../commons/adminHttpClient'
import { WizardStatus } from '../../../../domain/wizard/wizard'

export interface IchraBenefitDesignStateValues {
  benefitStartDate: string
  notificationDate: string
  isBenefitEditable: boolean
  planPeriodId: string
  wizardStatus: WizardStatus
  benefitEndDate: string
  runOutDays?: number
}

const getIchraBenefitDesignState = (planPeriodId: string): Promise<IchraBenefitDesignStateValues> => {
  return adminHttpClient.get(`AdminDashboard/ichra/BenefitDesignWizardState/${planPeriodId}`)
}

export default getIchraBenefitDesignState
